import { EnumValues } from './types/utility';
import { getBffUrl } from './util/getBffUrl';

export const SIDESHEET_CONTENT = {
  RELOAD: 'reload',
  HELP: 'help',
  SETTINGS: 'settings',
  PROFILE: 'profile',
  HISTORY: 'history',
  NOTIFICATION: 'notification',
  MEET_MY_CDK_TEAM: 'meet_my_cdk_team'
} as const;

export type SideSheetContent = EnumValues<typeof SIDESHEET_CONTENT>;

export const ENVIRONMENTS = {
  LOCAL: 'develop',
  STAGE: 'us-stage',
  DEV: 'us-dev',
  DIT: 'us-dit',
  PERF: 'us-perf',
  PROD: 'us-prod',
} as const;

export type Environments = EnumValues<typeof ENVIRONMENTS>;

export const URL_ROUTES = {
  workflows: '/workflows',
  applications: '/applications',
  myunify: '/myUnify',
  unifyAdmin: '/admin',
  aiva: '/aiva',
  pulse: '/pulse',
  dealerAdmin:'/dealer-admin',
  globalSearch: '/global-search',
  globalSearchHistory: '/global-search-history'
};


export const UNIFY_ADMIN_ROUTERS = {
  applicationAdmin: '/admin/applications',
  campaignAdmin: '/admin/campaigns',
  productOutageAdmin: '/admin/outages'
}

export const LOCAL_BASE_URL = process.env.REACT_APP_BFF;
export const PROD_BASE_URL = getBffUrl();
export const BYPASS_AUTH =
  process.env.REACT_APP_BYPASS_AUTH || process.env.NODE_ENV === 'test';
export const APP_ENV = process.env.REACT_APP_ENV || 'develop';
export const DRIVE_TITLE_ID = 'DMSDRIVE';
export const UNIFYADMIN_APP_ID = `${process.env.REACT_APP_UNIFYADMIN_APP_ID}`;
export const LOGOUT_URL = `${process.env.REACT_APP_LOGOUT_URL}`;
export const OKTA_LOGOUT_URL = `${process.env.REACT_APP_OKTA_LOGOUT_URL}`;
export const AG_GRID_LICENSE = `${process.env.REACT_APP_AG_GRID_LICENSE}`;
export const REACT_APP_NEWRELIC_LICENSE = `${process.env.REACT_APP_NEWRELIC_LICENSE}`;
export const REACT_APP_HARNESS = `${process.env.REACT_APP_HARNESS}`;
export const REACT_APP_DWM_ID = `${process.env.REACT_APP_DWM_ID}`;
export const REACT_APP_AHA_IDEA_WIDGET = `${process.env.REACT_APP_AHA_IDEA_WIDGET}`;
export const REACT_APP_AHA_PILOT_WIDGET = `${process.env.REACT_APP_AHA_PILOT_WIDGET}`;
export const REACT_APP_AHA_APPLICATION_ID = `${process.env.REACT_APP_AHA_APPLICATION_ID}`;
export const REACT_APP_VANITY_URL = `${process.env.REACT_APP_VANITY_URL}`;

export enum AMPLITUDE_EVENTS {
  VIEW_UNIFY_PAGE = 'Open Unify Page',
  OPEN_APPLICATION = 'Select Application',
  OPEN_WORKFLOW = 'Select Workflow',
  TAB_SELECTED = 'Tab Selected',
  LOGIN_UNIFY = 'Log in Unify',
  SINGLE_LOGIN_UNIFY = 'Single Log in Unify',
  LOGOUT_UNIFY = 'Log out Unify',
  CAMPAIGN_ACTIONS = 'Open Campaign Item',
  HEADER_ITEM_SELECTED = 'Header Item Selected',
  OPEN_HELP_TOPIC = 'Open Help Topic',
  HISTORY_ITEM = 'History Item',
  NOTIFICATION_DETAIL = 'Notification Detail',
  OPEN_FEEDBACK = 'Open Feedback',
  USER_GENERATED_CARD = 'Create New Link',
  OPEN_DRIVE = 'Open Drive',
  RECOMMENDATION_MODAL_SEEN = 'Recommendation Workflow Seen',
  OPEN_RECOMMENDATION_WORKFLOW = 'Open Recommended Workflow Page',
  OPEN_RECOMMENDATION_HELP = 'Open Recommended Help',
  RECOMMENDATION_REMIND_ME = 'Recommendation Remind Me Selected',
  RECOMMENDATION_PROCEED_DRIVE = 'Recommendation Proceed On Drive Selected',
  RECOMMENDATION_DISMISS = 'Recommendation Dismiss',
  DEALER_ADMINISTRATION = 'Dealer Administration',
  UNI_PULSE = 'UNI-Pulse',
  ADOPTEASE_TRYNOW_SEEN = 'AdoptEase Try Now Seen',
  ADOPTEASE_TOAST_SEEN = 'AdoptEase Toast Seen',
  ADOPTEASE_APPLICATION_MODAL_SEEN = 'AdoptEase Application Modal Seen',
  ADOPTEASE_APPLICATION_MODAL_CANCEL = 'AdoptEase Application Modal Cancel',
  ADOPTEASE_APPLICATION_MODAL_DISMISS = 'AdoptEase Application Modal Dismiss',
  OPEN_APPLICATION_FROM_ADOPTEASE = 'Open Application From Adoptease',
  OPEN_APPLICATION_TRAINING_FROM_ADOPTEASE = 'Open Training From Adoptease',
  ADOPTEASE_CAMPAIGN = 'AdoptEase Campaign',
  OPEN_IN_NEW_TAB = 'Open In New Tab',
  OPEN_ADAPTIVA_OSD_SINGLE_DMS_USER = 'Open Adaptiva OSD for Single DMS User',
  OPEN_ADAPTIVA_OSD_MULTI_DMS_USER = 'Open Adaptiva OSD for Multi DMS User',
  SCREEN_RESIZED = 'Screen Resized',
  SCREEN_RESOLUTION = 'Screen Resolution',
  CREATE_LINK = 'Create Link',
  SELECT_LEFTNAVITEM = 'Selected Left Nav Item',
  SELECT_DASHBOARD_LINK = 'Selected Dashboard Link',
  SAVE_DASHBOARD_SETTINGS = 'Dashboard Settings Saved',
  OPEN_AI_ANALYZE = 'Open AI Analyze',
  SET_STARTUP = 'Set Startup',
  VIEW_UNIFY_2_PAGE = 'Open Unify 2.0 Page',
  DASHBOARD_API_ERROR = 'Dashboard API Error',
  WIDGET_PERMISSION_DENIED = 'Widget Permission Denied'
}

export const SUPPORT_LINK =
  'https://www.cdkglobal.com/support-service-connect-top-level-support';

export const SPOKE_USERS = 'Spoke Users';

export enum APP_URL {
  'us-dev' = 'https://app-unify.app-dev.connectcdk.com',
  'us-dit' = 'https://app-unify.app-dit.connectcdk.com',
  'us-stage' = 'https://app-unify.app-stage.connectcdk.com',
  'us-perf' = 'https://app-unify.app-perf.connectcdk.com',
  'us-prod' = 'https://app-unify.app.connectcdk.com',
  'develop' = 'http://localhost:8080'
}

export enum DEVICE {
  'ANDROID' = 'ANDROID',
  'IOS' = 'IOS',
  'DESKTOP' = 'DESKTOP',
}

export const appUrlDiscovery = (environment: 'us-dev' | 'us-dit' | 'us-stage' | 'us-perf' | 'us-prod' | 'develop'): string => APP_URL[environment]

export const testUsers = ["nada.test@mailinator.com","unify.synthetic@mailinator.com"];

export const EMPTY_STRING = "";

export const STATUS_INDICATOR_VARIANTS = {
  "CUSTOM": "custom",
  "DEFAULT": "default",
  "INFORMATION": "information",
  "NEGATIVE": "negative",
  "POSITIVE": "positive",
  "WARNING": "warning"
};

export const WIDGET_DEFAULT_COLOR = '#457CCF';
